export const AMADEUS_AUTH_TOKEN = '/v1/security/oauth2/token';
export const FLIGHT_SEARCH = '/v2/shopping/flight-offers'
export const LOCATION_SEARCH = '/v1/reference-data/locations'
export const FLIGHT_PRICING = '/v1/shopping/flight-offers/pricing'
export const FLIGHT_ORDER = 'v1/booking/flight-orders'